import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Facturation.css";

const Facturation = () => {
    const navigate = useNavigate();

    // --- SÉCURITÉ STRICTE ---
    const userName = localStorage.getItem("userName") || "Invité";
    const isAuthorized = localStorage.getItem("canBilling") === "true";

    // --- ÉTATS ---
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(true);
    // NOUVEAU : État pour la recherche
    const [searchTerm, setSearchTerm] = useState("");
const handleReturnToWaiting = async (id) => {
    if (!window.confirm("Remettre ce dossier en 'Attente / Mi-Livré' ?")) return;

    try {
        await fetch("https://suivis.looktacom.fr/api/update_etape.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: id, id_etape: "19" }),
            credentials: "include"
        });
        // On retire de la liste locale puisque ce n'est plus l'étape 18
        setFactures(prev => prev.filter(f => f.id !== id));
    } catch (err) { 
        console.error("Erreur lors du retour en attente:", err); 
    }
};
    const fetchFactures = async () => {
        try {
            const res = await fetch("https://suivis.looktacom.fr/api/get_suivis.php?etape=18", { credentials: "include" });
            const data = await res.json();
            if (data.success) {
                const filteredData = data.data.filter(f => String(f.id_etape) === "18");
                setFactures(filteredData);
            }
        } catch (err) {
            console.error("Erreur factures:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleArchive = async (id) => {
        if (!window.confirm("Confirmer l'encaissement ? Le dossier passera en ARCHIVE.")) return;

        try {
            await fetch("https://suivis.looktacom.fr/api/update_etape.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: id, id_etape: "20" }),
                credentials: "include"
            });
            setFactures(prev => prev.filter(f => f.id !== id));
        } catch (err) { console.error(err); }
    };

    useEffect(() => {
        if (isAuthorized) {
            fetchFactures();
        } else {
            setLoading(false);
        }
    }, [isAuthorized]);

    // --- LOGIQUE DE FILTRAGE ---
    const filteredFactures = factures.filter(f => {
        if (!searchTerm) return true;
        const lowerTerm = searchTerm.toLowerCase();
        return (
            f.client_nom.toLowerCase().includes(lowerTerm) ||
            (f.num_bat && String(f.num_bat).includes(lowerTerm)) ||
            (f.num_facture && f.num_facture.toLowerCase().includes(lowerTerm)) || // <--- Ajouté ici
            (f.responsable_nom && f.responsable_nom.toLowerCase().includes(lowerTerm))
        );
    });

    // --- ÉCRAN ACCÈS REFUSÉ ---
    if (!isAuthorized) {
        return (
            <div className="facturation-page" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <div className="empty-state">
                    <div className="empty-icon">⛔</div>
                    <h3 style={{ color: '#E30613' }}>Accès Refusé</h3>
                    <p>Désolé <strong>{userName}</strong>, vous n'avez pas les droits pour accéder à la facturation.</p>
                    <button className="btn-back" onClick={() => navigate("/suivi-production")} style={{ marginTop: '30px', width: 'auto' }}>
                        Retour au Kanban
                    </button>
                </div>
            </div>
        );
    }

    if (loading) return <div className="facturation-page"><div className="loading-txt" style={{ margin: 'auto' }}>Chargement...</div></div>;

    return (
        <div className="facturation-page">
            <div className="facture-header">
                <button className="btn-back" onClick={() => navigate("/suivi-production")}>
                    ← Retour au Kanban
                </button>

                <div className="header-titles">
                    <h1>Comptabilité & Facturation</h1>
                    <p>{factures.length} dossier{factures.length > 1 ? 's' : ''} en attente de règlement</p>
                </div>

                {/* --- BARRE DE RECHERCHE --- */}
                <div className="search-bar-container">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="Rechercher (Client, Facture, BAT)..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                    {searchTerm && (
                        <button className="clear-search" onClick={() => setSearchTerm("")}>✖</button>
                    )}
                </div>
            </div>

            <div className="billing-container">
                <table className="billing-table">
                    <thead>
                        <tr>
                            <th>Client</th>
                            <th>Référence / BAT</th> {/* Changé le titre ici */}
                            <th>Échéance</th>
                            <th>Responsable</th>
                            <th className="th-actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* On utilise filteredFactures ici au lieu de factures */}
                        {filteredFactures.map((f) => (
                            <tr key={f.id} className="billing-row">
                                <td className="client-cell">
                                    <div className="client-name">{f.client_nom}</div>
                                </td>
                                <td>
                                    {/* --- NOUVEAU : Affichage du numéro de facture --- */}
                                    {f.num_facture && (
                                        <div style={{ color: '#29abe2', fontWeight: 'bold', marginBottom: '5px' }}>
                                            📄 {f.num_facture}
                                        </div>
                                    )}

                                    {f.num_bat ? <span className="bat-badge">BAT #{f.num_bat}</span> : <span className="no-bat">-</span>}
                                </td>
                                <td>
                                    {f.date_echeance ? new Date(f.date_echeance).toLocaleDateString('fr-FR') : "Aucune"}
                                </td>
                                <td>
                                    <div className="resp-badge">{f.responsable_nom || "?"}</div>
                                </td>
                                <td className="actions-cell">
    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        {/* Bouton Encaisser (déjà présent) */}
        <button className="btn-action btn-pay" onClick={() => handleArchive(f.id)}>
            💰 Encaisser
        </button>

        {/* NOUVEAU : Bouton Retour Facture */}
        <button 
            className="btn-action" 
            onClick={() => handleReturnToWaiting(f.id)}
            style={{ backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', padding: '8px 12px', cursor: 'pointer' }}
        >
            ↩️ Retour
        </button>
    </div>
</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Cas 1 : Aucune facture à la base */}
                {factures.length === 0 && (
                    <div className="empty-state">
                        <div className="empty-icon">🥂</div>
                        <h3>Tout est à jour !</h3>
                        <p>Aucun dossier en attente de paiement.</p>
                    </div>
                )}

                {/* Cas 2 : Factures existent mais la recherche ne donne rien */}
                {factures.length > 0 && filteredFactures.length === 0 && (
                    <div className="empty-state" style={{ marginTop: '50px' }}>
                        <div className="empty-icon" style={{ fontSize: '3rem' }}>🕵️‍♂️</div>
                        <h3 style={{ color: 'rgba(255,255,255,0.7)' }}>Aucun résultat</h3>
                        <p>Aucun dossier ne correspond à "{searchTerm}"</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Facturation;